import axios from 'axios';
import store from '../../Store';
import { receivedUserDetails } from './Actions';
import reducerRegistry from '../../ReducerRegistry';
import reducer from './Reducer';
reducerRegistry.register('user', reducer);
// Upon init, fetch the details for the authenticated user.
axios.get('/api/user/details').then((response) => {
    const userDetails = receivedUserDetails(response.data);
    store.dispatch(userDetails);
});
